import '../Default/_filter.scss';
import '../Default/_filter.dark-mode.scss';
import React, { useEffect, useMemo, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { ButtonToolbar, DropdownButton } from 'react-bootstrap';
import PropTypes from 'prop-types';
import qs from 'qs';
import classNames from 'classnames';

import VirtualList from './components/VirtualList';
import SimpleList from './components/SimpleList';
import SelectList from './components/Select';

import { doRequest } from './helpers';

const Dropdown = ({
  type,
  size,
  title,
  dropStyle,
  toolbarClass,
  disabled,
  onRequestFunc,
  items,
  queryRequest,
  withServicesId,
  clearData,
  withAll,
  fetchItems,
  onChangeSelect,
  value,
  darkMode,
  pullRight,
  active,
  isSorted,
  selectSearch,
  useDefaultValue,
}) => {
  const history = useHistory();
  const location = useLocation();

  const queryString = useMemo(() => qs.parse(location.search.slice(1)), [location.search]);
  const queryWithoutCurrentRequest = useMemo(() => {
    const queryObject = qs.parse(location.search.slice(1));
    delete queryObject[queryRequest]
    return qs.stringify(queryObject);
  }, [location.search, queryRequest]);

  const [clickCount, setClickCount] = useState(0);

  const doRequestFunc = (key) => doRequest(key, queryString, queryRequest, location, history, withAll);

  useEffect(() => {
    if (clearData) {
      clearData(location.state?.reload || '');
      setClickCount(0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryWithoutCurrentRequest]);

  const onClickToggler = () => {
    setClickCount((prev) => prev + 1);

    if (clickCount === 0) {
      onRequestFunc();
    }
  };

  const detectComponent = (type) => {
    switch (type) {
    case 'dropdown':
      return (
        <SimpleList
          items={items}
          withServicesId={withServicesId}
          doRequestFunc={doRequestFunc}
          queryString={queryString}
          queryRequest={queryRequest}
          withAll={withAll}
        />
      )

    case 'virtual':
      return (
        <VirtualList
          items={items}
          withServicesId={withServicesId}
          doRequestFunc={doRequestFunc}
          queryString={queryString}
          queryRequest={queryRequest}
          withAll={withAll}
        />
      )

    case 'select':
      return (
        <SelectList
          items={items}
          darkMode={darkMode}
          onChangeSelected={onChangeSelect}
          value={value}
          isSorted={isSorted}
          withServicesId={withServicesId}
          selectSearch={selectSearch}
          useDefaultValue={useDefaultValue}
        />
      )

    default:
      break;
    }
  }

  return (
    <ButtonToolbar className={toolbarClass}>
      <DropdownButton
        bsSize={size}
        title={title}
        bsStyle={dropStyle}
        id={`dropdown-size-${size || 'medium'}`}
        className={classNames('custom__filter-dropdown--button request__button', {
          'request__button-service': withServicesId,
          active: !!active,
        })}
        disabled={disabled}
        onClick={onClickToggler}
        pullRight={pullRight}
      >
        {items?.length === 0 && fetchItems ? (
          <li className="loader__li">
            <div className="small-loader" />
          </li>
        ) : items?.length === 0 && !fetchItems ? (
          <li className="empty__li">No result</li>
        ) : (
          detectComponent(type)
        )}
      </DropdownButton>
    </ButtonToolbar>
  );
};

Dropdown.propTypes = {
  type: PropTypes.string,
  size: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  dropStyle: PropTypes.string,
  toolbarClass: PropTypes.string,
  disabled: PropTypes.bool,
  items: PropTypes.array,
  onRequestFunc: PropTypes.func,
  queryRequest: PropTypes.string,
  withServicesId: PropTypes.bool,
  clearData: PropTypes.func,
  withAll: PropTypes.bool,
  fetchItems: PropTypes.bool,
  onChangeSelect: PropTypes.func,
  value: PropTypes.any,
  darkMode: PropTypes.number,
  active: PropTypes.bool,
  pullRight: PropTypes.bool,
  isSorted: PropTypes.bool,
  selectSearch: PropTypes.bool,
  useDefaultValue: PropTypes.bool,
};

Dropdown.defaultProps = {
  type: 'dropdown',
  title: 'default',
  dropStyle: 'default',
  items: [],
  withAll: false,
  pullRight: false,
  isSorted: false,
  selectSearch: true,
  useDefaultValue: true,
};

export default Dropdown;
